module.exports = __webpack_public_path__ + "img/banner2.edf0dc1e.jpg";